<div class="p-4 bg-light">
    <p>confirm-dialog works!</p>
</div>

<div class="p-dialog-footer pt-2">
    <p-button label="Ok" size="small" (onClick)="onClick()"></p-button>
</div>